import React, { Component } from 'react'
import MenuItemsList from './MenuItemsList'

let maxWidth = 0

class SiteNavigationDesktop extends Component {
    constructor(props) {
        super(props)

        this.state = {
            isSubNavigationOpen: false,
            menuWidth: 0,
            moreButtonWidth:0,
            hiddenMenuOpen: false
        }


        this.siteNavigationMenu = React.createRef()
        this.updateDimensions = this.updateDimensions.bind(this)
        this.getItemsOnlyWidth = this.getItemsOnlyWidth.bind(this)
        this.openHiddenMenu = this.openHiddenMenu.bind(this)
        this.getMoreButtonWidth = this.getMoreButtonWidth.bind(this)
        this.onMenuItemMouseEnter = this.onMenuItemMouseEnter.bind(this)
        this.onMenuItemMouseLeave = this.onMenuItemMouseLeave.bind(this)
    }

    openHiddenMenu() {
        const {hiddenMenuOpen} = this.state
        this.setState({
            hiddenMenuOpen: !hiddenMenuOpen
        })
    }

    componentDidMount() {
        if(this.siteNavigationMenu.current) {
            this.updateDimensions(this.siteNavigationMenu.current)
            this.setState({
                menuWidth: this.siteNavigationMenu.current.clientWidth
            })
            window.addEventListener("resize", () => {this.updateDimensions(this.siteNavigationMenu.current)})
        }
    }

    componentWillUnmount() {
        window.removeEventListener("resize", () => {this.updateDimensions()})
    }

    updateDimensions(siteNavigationMenu) {
        if(siteNavigationMenu) {
            const {menuWidth} = this.state
            if(menuWidth !== siteNavigationMenu.clientWidth) {
                this.setState({
                    menuWidth: siteNavigationMenu.clientWidth
                })
            }
        }
    }

    getMoreButtonWidth(current) {
        if(current) {
            const {moreButtonWidth} = this.state
            if(moreButtonWidth !== current.offsetWidth) {
                this.setState({
                    moreButtonWidth: current.offsetWidth
                })
            }
        }
    }

    getItemsOnlyWidth() {
        const {menuWidth, moreButtonWidth} = this.state
        if(!menuWidth || !moreButtonWidth) {
            if(menuWidth && !moreButtonWidth) {
                return maxWidth = menuWidth
            } else {
                return maxWidth
            }
        } else {
            maxWidth = menuWidth - moreButtonWidth
            return maxWidth
        }
    }


    onMenuItemMouseEnter() {
        const { addHtmlClass, toggleCinemaGroups } = this.props

        toggleCinemaGroups(false)

        this.setState({
            isSubNavigationOpen: true
        })

        addHtmlClass('navigation-is-active')

    }

    onMenuItemMouseLeave() {
        const { removeHtmlClass, toggleCinemaGroups } = this.props

        toggleCinemaGroups(false)


        this.setState({
            isSubNavigationOpen: false
        })

        removeHtmlClass('navigation-is-active')
    }

    render() {
        const { menuWidth, hiddenMenuOpen } = this.state
        const {menuItemsData, translation, programOverviewSubmenus, movies, attributes} = this.props
        const maxWidthForItems = this.getItemsOnlyWidth()

        return (
            <nav id="main-navigation" className="site-navigation site-navigation-desktop" role="navigation" aria-label="Menü">
                <div ref={this.siteNavigationMenu} className="menu-container">  
                    <MenuItemsList
                        hiddenMenuOpen={hiddenMenuOpen}
                        maxWidthForItems={maxWidthForItems}
                        programOverviewSubmenus={programOverviewSubmenus}
                        translation={translation}
                        menuItemsData = {menuItemsData}
                        menuWidth={menuWidth}
                        onMouseEnter={this.onMenuItemMouseEnter}
                        onMouseLeave={this.onMenuItemMouseLeave}
                        getMoreButtonWidth={this.getMoreButtonWidth}
                        onClick={this.openHiddenMenu}
                        movies={movies}
                        attributes={attributes}
                    />
                </div>
            </nav>
        )
    }
}

export default SiteNavigationDesktop